import * as React from 'react';

import { FileUpload } from '../../../../packages/fileUpload/components/FileUpload';
import { useDropZone } from '../../../../packages/fileUpload/utils/useDropZone';
import {
  FileDropZone,
  FileListView,
  FileUploadError,
} from '../../../../packages/fileUpload/components/FileUpload/components';
import { useMultipleFilesUploadField } from './utils';
import { mapDocumentToFieldValue } from '../../../../packages/fileUpload/mappers';

export interface IMultipleFilesUploadContainerProps {
  name: string;
}

export const MultipleFilesUploadContainer: React.FC<IMultipleFilesUploadContainerProps> = props => {
  const { isLoading, error, value, name, handleFileRemove, handleFileSelect, fileInputKey, touched } =
    useMultipleFilesUploadField(props);

  const { showDropZone } = useDropZone({
    onFileDrop: handleFileSelect,
  });

  return (
    <>
      <FileUpload
        key={fileInputKey}
        name={name}
        onFileSelect={handleFileSelect}
        isLoading={isLoading}
        multiple
        buttonText="Выберите документы"
        descriptionText="или перетащите их в эту область"
      />

      {touched && error && <FileUploadError error={error} />}

      {value && value.length > 0 && (
        <FileListView list={value.map(mapDocumentToFieldValue)} onDelete={handleFileRemove} />
      )}

      {!isLoading && showDropZone && <FileDropZone />}
    </>
  );
};

MultipleFilesUploadContainer.displayName = 'MultipleFilesUploadContainer';
